<template>
  <div>
    <div class="rew19_select_intitle">
      <em>매월</em>
      <span class="rew19_form_full">
        <select class="rew19_select_t1 autoFocus" v-model="paymentDay">
          <option value="1">결제일 1일</option>
          <option value="2">결제일 2일</option>
          <option value="3">결제일 3일</option>
          <option value="4">결제일 4일</option>
          <option value="5">결제일 5일</option>
          <option value="6">결제일 6일</option>
          <option value="7">결제일 7일</option>
          <option value="8">결제일 8일</option>
          <option value="9">결제일 9일</option>
          <option value="10">결제일 10일</option>
          <option value="11">결제일 11일</option>
          <option value="12">결제일 12일</option>
          <option value="13">결제일 13일</option>
          <option value="14">결제일 14일</option>
          <option value="15">결제일 15일</option>
          <option value="16">결제일 16일</option>
          <option value="17">결제일 17일</option>
          <option value="18">결제일 18일</option>
          <option value="19">결제일 19일</option>
          <option value="20">결제일 20일</option>
        </select>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "WishPayment",
  data() {
    return{
      paymentDay: 1
    }
  },
  methods: {
    getData(){
      let _this = this;

      return _this.paymentDay;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/payment/WishPayment.vue